export const API_HOST = process.env.REACT_APP_API_HOST;
export const CSRF_TOKEN_NAME = 'X-CSRFToken';

export const COMETCHAT_CONFIG = {
    APP_ID: process.env.REACT_APP_COMETCHAT_APP_ID,
    REGION: process.env.REACT_APP_COMETCHAT_REGION,
}
